<template>
    <div class="hotline-banner">
        <div class="_mb-0-16">
            <div class="h2 _mb-8" v-html="title"></div>
            <div class="p1" v-html="subtitle"></div>
        </div>

        <div class="_align-items-start _dflex">
            <div class="ico_bg ico_color_blue ico_bg-40-32 _br-8 _mr-16">
                <span class="ico ico-phone ico_color_black ico_size_24-16"></span>
            </div>
            <div>
                <a href="tel:+78007758686" class="h2 _pb-8">8 800 775-86-86</a>
                <div v-if="addNumber" class="p1" v-html="addNumber"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Hotline',
    props: {
        addNumber: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: 'Горячая линия для клиентов 24/7'
        },
        subtitle: {
            type: String,
            default: 'Круглосуточно и бесплатно по России'
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/base/_variables.scss';
    @import '../../assets/scss/base/_mixins.scss';
    @import '../../assets/scss/base/_functions.scss';

    .hotline-banner {
        background-color: $blue-117;
        @include fluid('padding-top', 32px, 24px);
        @include fluid('padding-bottom', 32px, 24px);
        @include fluid('padding-left', 56px, 16px);
        @include fluid('padding-right', 56px, 16px);
        @include fluid('border-radius', 24px, 24px);
        display: flex;
        justify-content: space-between;

        @include mobile {
            flex-wrap: wrap;
        }
    }
</style>
